export function LoadingSpinner() {
  return (
    <div className="mx-auto h-5 w-5 animate-spin rounded-full border-2 border-transparent border-t-white"></div>
  );
}
